import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantSelectionService } from 'src/app/Services/tenant-selection.service';
import { environment } from 'src/environments/environment';
import { BuildAuthService } from 'src/app/Services/build-auth.service';
import { AbstractRepository } from '../repository/abstract-repository';
import { promise } from 'protractor';


@Injectable({
    providedIn: 'root'
})
export class NutzerRepository extends AbstractRepository<User> {

    constructor(private http: HttpClient, private tenantService: TenantSelectionService, private authBuilder: BuildAuthService) {
        super();
    }

    getUrl(): string {
        return `${environment.backendURL}/${this.authBuilder.buildAuth()}/nutzer`;
    }

    getAll(): Promise<User[]> {

        return new Promise((resolve, reject) => {
            this.http.get(this.getUrl()).subscribe((res: User[]) => {
                resolve(res);
            });
        });
    }

    getWithID(id: number): Promise<User> {
        throw new Error('Method not implemented.');
    }

    update(object: User): Observable<any> {
        return this.http.post(`${this.getUrl()}/update`, object);
    }

    post(object: User): Observable<any> {
        return this.http.post(this.getUrl(), object);
    }
    delete(id: number): Observable<any> {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            body: {
                'ID': id
            }
        };
        return this.http.delete(this.getUrl(), options);
    }
    getUrlForImport(): string {
        return `${environment.backendURL}/${this.authBuilder.buildAuth()}/nutzerImport`;
    }
    getCsvHeaders(): string[] {
        return [ // Spalten für die generierte .csv Datei
            'Name',
            'Login',
            'Berechtigungsgruppe'
        ];
    }
    import(importObjects: User[]) {
        return this.http.post(this.getUrlForImport(), importObjects);
    }
    getRepoName(): string {
        throw new Error('Method not implemented.');
    }

    buildObject(
        Login: string,
        Name: string,
        PermissionGroupID: number,
        ID?: number,
    ): User {
        return {
            Login,
            Name,
            PermissionGroupID,
            ID,
            tenant: this.tenantService.getCurrentTenantID()
        };
    }
    buildImportObjects(importObjectStringArray): User[] {

        const objectsFromCsv: User[] = [];

        for (let i = 1; i < importObjectStringArray.length; i++) {
            const Name = importObjectStringArray[i][0];
            const Login = importObjectStringArray[i][1];
            const Berechtigungsgruppe = parseInt(importObjectStringArray[i][2], 10);

            objectsFromCsv.push(this.buildObject(
                Name,
                Login,
                Berechtigungsgruppe
            ));
        }
        return objectsFromCsv;
    }
}
